export default __webpack_public_path__ + "static/start-ff72adb3b03229a55a3b1b901d85b12e.png";